import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-material.css'
import { ContactQueueGrid } from './ContactQueueGrid'
import { UserActiveContactQueueGrid } from './UserActiveContactQueueGrid'
import { Tab, TabList, TabPanel, Tabs } from '@calabriocloud/beacon-ui'

export const ContactQueue = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <div className="bg-white flex flex-col h-full">
      <div className="px-[54px] py-[12px] flex justify-between border-b border-black bg-white sticky top-0 z-20">
        <h1 className="text-xl font-bold" data-testid="contact-queue-title">{t('contactQueue')}</h1>
      </div>
      <br data-testid="contact-queue-break" />
      <div className="w-full px-[40px] mt-4" data-testid="contact-queue-tabs-container">
        <Tabs className="gap-0" data-testid="contact-queue-tabs">
          <TabList data-testid="contact-queue-tab-list">
            <Tab id="interactions" data-testid="contact-queue-tab-interactions">{t('recordings')}</Tab>
            <Tab id="mycontactgoals" data-testid="contact-queue-tab-goals">{t('goals')}</Tab>
          </TabList>
          <TabPanel id="interactions" className="p-0" data-testid="contact-queue-tab-panel-recordings">
            <ContactQueueGrid data-testid="contact-queue-grid" />
          </TabPanel>
          <TabPanel id="mycontactgoals" className="p-0 mt-11" data-testid="contact-queue-tab-panel-goal-status">
            <UserActiveContactQueueGrid data-testid="contact-queue-grid-goals-status" />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

